export const ComplaintsColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Тип жалобы',
        key: 'type',
    },
    {
        name: 'Отвественный отдел',
        key: 'culpritSide',
    },
    {
        name: 'Компания',
        key: 'companyName',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'Дата создания',
        key: 'createdAt',
    },
    {
        name: 'Инициатор',
        key: 'initiator',
    },
    {
        name: 'Источник',
        key: 'source',
    },
    {
        name: 'Жалоба на',
        key: 'complaintTo',
    },
    {
        name: 'Объект жалобы',
        key: 'object',
    },
]

export const ComplaintsIdColumns = ['type', 'status']

export const ComplaintsTypes = []
